export * from './Slider'



// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/Slider/index.tsx